/*
vue-i18n (v8.x) guide
https://kazupon.github.io/vue-i18n/guide/formatting.html
*/
import { formattedDate } from './dateTimeFormatter.ts';

const enUS = {
    labels: {
        about: 'About',
        aboutme: 'About me',
        acceptprivacy: 'I have read and accept the {0}',
        acceptterms: 'I have read and accept the {0}',
        acceptprivacyandterms: 'I have read and accept the {0} and the {1}',
        accesskey: 'Access key',
        accesspolicy: 'Access Policy',
        accessibilitypolicy: 'Accessibility Policy',
        account: 'Account',
        accountsettings: 'Account settings',
        activity: 'Activity',
        active: 'Active',
        inactive: 'Inactive',
        activemembers: 'Active members',
        activatepayments: 'Activate payments',
        add: 'Add',
        address: 'Address',
        addressadditionalinformation: 'Additional information',
        addsection: 'Add Section',
        addtogoogle: 'Add to Google',
        addtooutlook: 'Add to Outlook',
        saveasicsfile: 'Save as ICS',
        addvideoconferencelink: 'Video conference link',
        addvideoconferencelinkplaceholder: 'https://',
        adminremove: 'Remove administrator',
        adminadd: 'Add administrator',
        all: 'All',
        textSection: 'Text Section',
        imageSection: 'Image Section',
        amount: 'Amount',
        and: 'and',
        announcement: 'Announcement',
        announcementmake: 'Make @.lower:labels.announcement',
        announcementsentby: '@:labels.announcement sent by {name}',
        archived: 'Archived',
        archive: 'Archive',
        aspectratio: 'Aspect ratio',
        aspectratiolandscape: 'Landscape',
        aspectratioportrait: 'Portrait',
        aspectratiosquare: 'Square',
        unarchive: 'Unarchive',
        attend: 'Attend',
        attendees: 'Attendees',
        author: 'Author',
        availability: 'Availability',
        awaynotice: 'Away notice',
        back: 'Back',
        birthdate: 'Date of birth',
        billing: 'Billing',
        billingaddress: 'Billing address',
        billingaddressedit: '@:labels.edit @.lower:labels.billingaddress',
        book: 'Book',
        booking: 'Booking',
        bookingcancel: '@:labels.cancel @.lower:labels.booking',
        bookingconditions: '@:labels.booking conditions',
        bookingconfirm: 'Book now',
        bookingconfirmpaid: 'Complete paid booking',
        bookingBy: 'Created by',
        bookingFor: 'Booking for',
        bookings: 'Bookings',
        bookingsmy: 'My Bookings',
        bookingsupcoming: 'Upcoming bookings',
        bookingshistory: 'Bookings history',
        buy: 'Buy',
        buynow: 'Buy now',
        by: 'By',
        byme: '@:labels.mine',
        cancel: 'Cancel',
        canceled: 'Canceled',
        cancellationnotice: 'Cancellation notice',
        cancellationnoticemessage: 'Cancellation possible up to {days} days before the event.',
        cancellationpolicy: 'Cancellation policy',
        cancellationpolicyindays: 'Cancellation policy (in days)',
        cf: {
            addCustomField: 'Add Custom Field',
            label: 'Label',
            identifier: 'Identifier',
            dataType: 'Data Type',
            optionsValues: 'Options Values',
            optionsValuesHint: 'Comma separated values for select/multiselect',
            visibility: 'Visibility',
            editability: 'Editability',
            requestedOnSignUp: 'Requested on Sign Up',
            sortOrder: 'Sort Order',
            editCustomField: 'Edit Custom Field',
            datatypetext: 'Text',
            datatypenumber: 'Number',
            datatypedate: 'Date',
            datatypeboolean: 'Boolean',
            datatypeselect: 'Select',
            datatypemultiselect: 'Multi Select',
            visibilityadmin: 'Admin',
            visibilityowner: 'Owner',
            visibilitycommunity: 'Community',
            visibilitypublic: 'Public',
            editabilityadmin: 'Admin',
            editabilityowner: 'Owner',
            requestedonsignupnone: 'None',
            requestedonsignupoptional: 'Optional',
            requestedonsignuprequired: 'Required',
        },
        changes: 'Changes',
        changessaved: '@:messages.changessaved',
        channel: 'Channel',
        channelname: '@:labels.channel @.lower:labels.name',
        channelnew: '@:labels.new @.lower:labels.channel',
        channeladd: '@:labels.add @.lower:labels.channel',
        channels: 'Channels',
        chat: 'Chat',
        chatnew: '@:labels.new @.lower:labels.chat',
        checkout: 'Checkout',
        category: 'Category',
        city: 'City',
        clear: 'Clear',
        clearall: 'Clear all',
        close: 'Close',
        closed: 'Closed',
        codeSection: 'Code Section',
        color: 'Color',
        colorbackground: 'Background color',
        colorforeground: 'Foreground color',
        comment: 'Comment',
        commentdelete: '@:labels.delete @.lower:labels.comment',
        comments: 'Comments',
        community: 'Community',
        communityrecentlyseen: 'Recently seen online',
        company: 'Company',
        complete: 'Complete',
        confirm: 'Confirm',
        confirmationcode: 'Confirmation code',
        configuration: 'Configuration',
        contact: 'Contact',
        contributor: 'Contributor',
        contributers: 'Contributors',
        contributersadd: 'Add contributors',
        continue: 'Continue',
        copy: 'Copy',
        couponcode: 'Coupon code',
        country: 'Country',
        create: 'Create',
        creator: 'Creator',
        created: 'Created',
        createdat: '@:labels.created at',
        createdon: '@:labels.created on',
        credit: 'Credit',
        credits: 'Credits',
        creditssummary: 'Credits summary',
        creditsused: 'Credits used',
        creditsbeforebooking: 'Credits available in this billing cycle before this booking',
        creditsafterbooking: 'Credits remaining in this billing cycle after this booking',
        creditstotal: 'Total credits in this billing cycle',
        day: 'Day | Days',
        date: 'Date',
        dateempty: 'No date selected',
        description: 'Description',
        delete: 'Delete',
        details: 'Details',
        default: 'Default',
        discard: 'Discard',
        draft: 'Draft',
        dragdropimage: 'Drag an image here or click to select.',
        duration: 'Duration',
        edit: 'Edit',
        email: 'Email',
        embed: 'Embed',
        embedcode: 'Embed code',
        enabled: 'enabled',
        enddate: 'End date',
        endtime: 'End time',
        ended: 'Ended',
        event: 'Event',
        eventcreate: '@:labels.create @.lower:labels.event',
        eventcreated: '@:labels.event @.lower:labels.created',
        eventdelete: '@:labels.delete @.lower:labels.event',
        eventedit: '@:labels.edit @.lower:labels.event',
        eventtime: 'Time',
        events: 'Events',
        eventsall: 'All events',
        eventsupcoming: 'Upcoming events',
        eventsupcomingpublic: 'Next public events',
        eventsnext: 'Next events',
        eventOngoing: 'Ongoing',
        eventyour: 'your @.lower:labels.event',
        expiresAt: 'Expires at',
        failedGeneric: '@:errors.failedGeneric',
        failedToSaveChanges: '@:errors.failedToSaveChanges',
        feed: 'Feed',
        finish: 'Finish',
        follow: 'Follow',
        followerrole: 'Follower',
        follower: 'no followers | one follower | {n} followers',
        followers: 'Followers',
        following: 'Following',
        free: 'free',
        from: 'From',
        fromprice: '@:labels.from',
        general: 'General',
        getstarted: 'Get started',
        getticket: 'Get Ticket',
        going: 'Going',
        goingcount: 'is going | are going',
        group: 'Group',
        groupmember: 'Group member | Group members',
        groupnew: '@:labels.new @.lower:labels.group',
        guest: 'Guest',
        hashtag: 'Hashtag',
        hashtagadd: '@:labels.add @.lower:labels.hashtag',
        headline: 'Headline',
        help: 'Help',
        hidden: 'Hidden',
        hide: 'Hide',
        hour: 'hour | hours',
        hourshort: 'h',
        imprint: 'Imprint',
        import: 'Import',
        image: 'Image',
        imageadd: '@:labels.add @.lower:labels.image',
        imageguidelines: 'Image Guidelines',
        inapp: 'In-app',
        including: 'incl.',
        information: 'Information',
        interested: "I'm interested",
        interestedpeople: 'Interested',
        interestedsent: 'Request sent',
        invalid: 'Invalid',
        invitemember: 'Invite member',
        invoice: 'Invoice',
        invoices: 'Invoices',
        invoicenext: 'Next Invoice',
        invoicepreview: 'Invoice preview',
        itemscount: 'no items | 1 item | {n} items',
        join: 'Join',
        keepBooking: 'Keep booking',
        key: 'Key',
        keyimport: 'Import',
        keymanagement: 'Key Management',
        keycreate: '@:labels.create a @.lower:labels.key',
        keyassign: 'Assign a @.lower:labels.key',
        keynotassigned: 'No @.lower:labels.key assigned',
        language: 'Language',
        last4digits: 'Last four digits',
        letstalkabout: "Let's talk about",
        link: 'Link',
        linkadd: '@:labels.add @.lower:labels.link',
        linkcopy: '@:labels.copy @.lower:labels.link',
        linkInvalid: 'Invalid invitation link',
        linkInvalidDescription:
            'The link has expired, has been used before or has been deleted. Please try again. If the issue keeps happening, contact a Community Manager.',
        links: 'Links',
        limitUsersAlmostReached: 'Limit almost reached',
        limitUsersReached: 'You have reached the limit',
        loaded: 'loaded',
        loading: 'loading',
        loadmore: 'Load more',
        location: 'Location',
        locationcreate: '@:labels.create @.lower:labels.location',
        locationedit: '@:labels.edit @.lower:labels.location',
        login: 'Log in',
        logout: 'Log out',
        markallasread: 'Mark all as read',
        market: 'Market',
        marketitem: 'Market item',
        marketitems: 'Market items',
        marketitemyour: 'your @.lower:labels.marketitem',
        marketitemclose: '@:labels.close @.lower:labels.marketitem',
        marketitemcreate: '@:labels.create @.lower:labels.marketitem',
        marketitemdelete: '@:labels.delete @.lower:labels.marketitem',
        marketitemedit: '@:labels.edit @.lower:labels.marketitem',
        mine: 'Mine',
        maxamount: 'Max. amount',
        month: 'Month',
        more: 'More',
        morecount: '{count} more',
        mentionsmo: 'Mention someone',
        member: 'Member | Members',
        members: 'Members',
        membership: 'Membership',
        membershipyour: 'Your @.lower:labels.membership',
        message: 'Message',
        messagenew: '@:labels.new @:labels.message',
        messenger: 'Messenger',
        minamount: 'Min. amount',
        monetizationCollection: {
            subscriptions: {
                monetization: 'Monetization',
                pricing: 'Pricing',
                billing: 'Billing',
                invoices: 'Invoices',
                paymentmethods: '@:labels.paymentmethods',
                minduration: 'Minimum contract term',
                // the minimum time before the next billing cycle to for subscribers to cancel their subscription
                cancelnotice: 'Cancellation notice period',
            },
        },
        my: 'My',
        mybookings: '@:labels.my @.lower:labels.bookings',
        myevents: '@:labels.my @.lower:labels.events',
        mypages: '@:labels.my @.lower:labels.pages',
        mywallet: '@:labels.my @.lower:labels.wallet',
        myticket: '@:labels.my @.lower:labels.ticket',
        name: 'Name',
        namefirst: 'First name',
        namelast: 'Last name',
        numberoftickets: 'Number of Tickets',
        next: 'Next',
        new: 'New',
        net: 'Net',
        no: 'No',
        note: 'Note',
        noteadd: 'Add a note',
        notificationpreferences: 'Notification preferences',
        notifications: 'Notifications',
        notificationspause: 'Pause notifications',
        notificationspaused: 'Notifications paused',
        notifymewhen: 'Notify me when',
        notifymewhenasadmin: 'Me as an admin',
        notprovided: 'not provided',
        nooptions: 'No options',
        noresults: 'No results',
        of: 'of',
        ok: 'OK',
        option: 'Option',
        options: 'Options',
        optionsdisplay: 'Display options',
        or: 'or',
        orderconfirm: 'Confirm order',
        ordercompletesubcription: 'Complete paid subscription',
        ordercompletesubcriptionfree: 'Complete free subscription',
        orderreview: 'Review',
        ordercheckout: 'Checkout',
        ordersummary: 'Order summary',
        organizer: 'Organizer',
        organizers: 'Organizers',
        organizersadd: '@:labels.add @:labels.organizers',
        others: 'no one | one other | {n} others',
        owner: 'Owner',
        owners: 'Owners',
        ownersadd: 'Add owners',
        pagecreate: '@:labels.create @.lower:labels.page',
        pagecreated: '@:labels.page @.lower:labels.created',
        pagedelete: '@:labels.delete @.lower:labels.page',
        pageedit: '@:labels.edit @.lower:labels.page',
        pagepublish: '@:labels.publish @.lower:labels.page',
        pagepublished: '@:labels.page @.lower:labels.published ',
        page: 'Page',
        pages: 'Pages',
        pageyour: 'your @.lower:labels.page',
        pagesmy: '@:labels.mypages',
        paid: 'paid',
        password: 'Password',
        passwordreset: 'Reset password',
        passwordsave: 'Save password',
        passwordsetnew: 'Set a new password',
        pause: 'Pause',
        payment: 'Payment',
        paymentmethod: 'Payment method',
        paymentmethodadd: '@:labels.add @.lower:labels.paymentmethod',
        paymentmethods: 'Payment methods',
        per: 'Per',
        phoneNumber: 'Phone number',
        phonenumber: '@:labels.phoneNumber',
        phonenumbernotprovided: '@:labels.phonenumber @:labels.notprovided',
        pay: 'Pay',
        plan: 'Plan',
        plancancel: 'Cancel plan',
        planchange: 'Change plan',
        planedit: 'Edit plan',
        planchangecancel: 'Cancel plan change',
        planchoose: 'Choose plan',
        plancurrent: 'Your @.lower:labels.plan',
        plannew: 'New @.lower:labels.plan',
        planreactivate: 'Undo cancellation',
        planselection: 'Choose your plan',
        planupcoming: 'Upcoming plan',
        planupgrades: 'Plan upgrades',
        planupgradechose: 'Select your plan upgrades',
        post: 'Post',
        postpublished: '@:labels.post @.lower:labels.published',
        postyour: 'your @.lower:labels.post',
        postalcode: 'ZIP code',
        postbtn: '@:labels.post',
        postedit: '@:labels.edit @.lower:labels.post',
        policy: 'Policy',
        policyimport: 'Import',
        policynotassigned: 'No policy assigned',
        preview: 'Preview',
        previous: 'Previous',
        profile: 'Profile',
        profileedit: '@:labels.edit @:labels.profile',
        profilepublish: '@:labels.publish @.lower:labels.profile ',
        profilepublished: '@.lower:labels.profile @:labels.published',
        profileupdated: '@:labels.profile @.lower:labels.updated',
        profilename: 'Profile name',
        price: 'Price',
        pricedisplay: 'Display price',
        pricenet: 'Net',
        pricegross: 'Gross',
        pricepreview: 'Price preview',
        pricesubtotal: 'Subtotal',
        pricetotal: 'Total',
        pricevaries: 'prices vary',
        privacypolicy: 'Privacy Policy',
        publish: 'publish',
        published: 'published',
        pushnotification: 'Push notification',
        push: 'Push',
        quantity: 'Quantity',
        readless: 'read less',
        readmore: 'Read more',
        redeem: 'Redeem',
        redeemable: 'Redeemable',
        redeemed: 'Redeemed',
        refunded: 'refunded',
        refresh: 'Refresh',
        registrationconfirmation: 'Registration confirmation',
        remaining: 'left',
        remove: 'Remove',
        reopen: 'Reopen',
        reopenItem: 'Reopen item',
        reply: 'Reply',
        reportbug: 'Report a bug',
        reset: 'Reset',
        resolve: 'Resolve',
        resource: 'Resource',
        resources: 'Resources',
        review: 'Review',
        required: 'Required',
        salutation: 'Salutation',
        salutationfemale: 'Ms.',
        salutationmale: 'Mr.',
        salutationnonbinary: 'Mrx.',
        save: 'Save',
        saved: 'saved',
        scrolltotop: 'Scroll to top',
        seeall: 'See all',
        selectall: 'Select all',
        setAsDefault: 'Set as Default',
        send: 'Send',
        share: 'Share',
        skip: 'Skip',
        signup: 'Sign up',
        start: 'Start',
        startdate: 'Start date',
        starttime: 'Start time',
        status: 'Status',
        submit: 'Submit',
        subscriptioncreate: 'Create subscription',
        suggestedcontent: 'Suggested content',
        summary: 'Summary',
        sold: 'Sold',
        soldout: 'Sold out',
        systemid: 'System ID',
        systemuserid: '{systemname} System User ID',
        tags: 'Tags',
        tax: 'Tax',
        taxrate: 'Tax rate',
        terms: 'Terms',
        termsandconditions: 'Terms and Conditions',
        termsofservice: 'Terms of Service',
        ticket: 'Ticket',
        tickets: 'Tickets',
        ticketstatus: 'Ticket status',
        ticketurl: 'Ticket link',
        ticketcreate: 'Create ticket',
        ticketedit: 'Edit ticket',
        ticketcode: 'Ticketcode',
        time: 'Time',
        timepass: 'Time pass',
        timezone: 'Timezone',
        title: 'Title',
        to: 'To',
        today: 'Today',
        topics: 'Topics',
        total: 'Total',
        tryagain: 'Try again',
        type: 'Type',
        unfollow: 'Unfollow',
        user: 'User',
        unit: 'Unit',
        unsavedchanges: 'Unsaved changes',
        updated: 'Updated',
        updatedat: '@:labels.updated at',
        updatedon: '@:labels.updated on',
        update: 'Update',
        updatecreate: '@:labels.create @.lower:labels.update',
        updatedelete: '@:labels.delete @.lower:labels.update',
        updateedit: '@:labels.edit @.lower:labels.update',
        updates: 'Updates',
        upgrades: 'Upgrades',
        upgradeSubscription: 'Upgrade Subscription',
        valid: 'Valid',
        validfor: 'Valid for',
        validfrom: 'Valid from',
        validto: 'Valid to',
        validuntil: 'Valid until',
        vat: 'VAT',
        vatid: 'VAT ID',
        vatidnotprovided: 'VAT ID not provided',
        view: 'View',
        vieweventdetails: 'View event details',
        visibility: 'Visibility',
        week: 'Week',
        welcometocoapp: 'Welcome to coapp',
        wallet: 'Wallet',
        yes: 'Yes',
        year: 'Year',
        you: 'You',
        roles: {
            admin: 'Admin',
            user: 'User',
        },
        rules: {
            add_group: 'Add rule',
            add_condition: 'Add condition',
            remove_condition: 'Remove condition',
            conditions: {
                AND: 'And',
                OR: 'Or',
            },
            fields: {
                user_id: 'User',
                user_role: 'User role',
                user_status: 'User status',
                user_email: 'User email',
                plan_id: 'Plan',
            },
            operators: {
                EQ: 'is equal to',
                NEQ: 'is not equal to',
                GT: 'greater than',
                GTE: 'greater than or equal to',
                LT: 'less than',
                LTE: 'less than or equal to',
                LIKE: 'contains',
                NOTLIKE: 'does not contain',
                BETWEEN: 'is between',
                ANY: 'is any',
            },
        },
    },
    placeholders: {
        cf: {
            // custom fields related placeholders
            label: 'Enter label',
            identifier: 'Enter identifier',
            dataType: 'Select data type',
            visibility: 'Select who can see',
            editability: 'Select who can edit',
            requestedOnSignUp: 'Select sign up option',
            sortOrder: 'Enter sort order',
            optionsValues: 'e.g. option 1,option 2,option 3',
        },
        selectTimezone: 'Select a timezone',
        communityname: 'Name your community',
        address: 'Street and number',
        addressadditionalinformation: "e.g. 'Appartment No. 1'",
        autocompleteempty: 'No results',
        comment: 'Leave a comment',
        note: 'Add a Note',
        couponcode: 'Enter coupon code',
        date: 'Chose a date',
        email: 'mail@example.com',
        file: 'No file selected',
        image: 'Click to change the image',
        marketitemcontact: 'link to a contact page or email',
        marketitemdescription:
            'The description of your item will be displayed on the detail page of your item and should describe it in detail.',
        marketitemtitle: 'Chose a good title :)',
        marketitemsummary: 'The summary of your item will be displayed in the feed and in the market list.',
        messagecreate: 'Write a message ...',
        optional: 'optional',
        password: 'enter your password',
        post: '@:labels.create @.lower:labels.post',
        posteditor: 'Write here ...',
        editorCode: '<html>Add your code here ...</html>',
        postalcode: '12345',
        search: 'search',
        searchaccesskey: 'Search access key to assign',
        searchaccesspolicy: 'Search access policy to assign',
        searchmembers: 'Search for members',
        select: '@:placeholders.selectplease',
        selecttaxrate: 'Select tax rate',
        selectplease: 'Please select an option',
        tags: 'Start typing',
        updatecreate: '@:labels.create @.lower:labels.update',
        ticketurlplaceholder: 'External ticket link',
        ticketname: 'e.g. Early Bird',
        termsandconditions: ' ',
        vatid: 'GB123456789',
    },
    messages: {
        accountexists: 'Already have an account?',
        cookiebanner:
            'This site uses cookies 🍪 to store information on your computer. Some are essential to make our site work; others help us improve the user experience. By using this site, you consent to the placement of these cookies. Read our {privacypolicy} to learn more.',
        copyshareablelink: 'Copy shareable link',
        copiedtoclipboard: 'Copied to clipboard',
        cf: {
            // custom fields related messages
            createdSuccessfully: 'Custom field created successfully.',
            creationFailed: 'Failed to create custom field.',
            deletewarning:
                'Deleting this custom field will also delete all associated data from member profiles. This action cannot be undone. Please be certain.',
            deletedSuccessfully: 'Custom field deleted successfully.',
            updatedSuccessfully: 'Custom field updated successfully.',
            updateFailed: 'Failed to update custom field.',
        },
        enterconfirmationcode: 'Enter confirmation code',
        confirmationcodesentotemail: 'Enter the confirmation code we sent to {email}',
        confirmationcodeinfo: 'Didnt receive a code? Check you spam folder, or try a different email address',
        resendconfirmationcodein: 'Resend code in {countdown}',
        resendconfirmationcode: 'Resend code',

        deletewarning: 'Once you delete this, there is no going back. Please be certain.',
        deleteImageHeaderWarning: 'Are you sure you want to delete this image?',
        event: {
            linkvisibleforattendees: 'Link visible for attendees',
            attendanceCancellation: 'Are you sure about this? This event would be much nicer with you!',
            ticketRefund: 'Refund',
            ticketRefundTitle: 'Ticket cancellation and refund',
            ticketIsNotRefundable: 'This ticket cannot be refunded.',
            ticketRefundDescription: 'Refund might take up to 5-7 days to process.',
            ticketRefundSuccess: 'Your ticket has been successfully canceled and refunded.',
            ticketRefundError: 'An error occurred while processing your refund. Please try again.',
            billingAddressInfo:
                'This billing address will be used for all future invoices. You can change it at any time.',
        },
        booking: {
            nobookings: "You don't have any upcoming bookings. You can create one right now!",
            cancellationinfo:
                'Booking cancellation less than {hours} hours before the event start time is not allowed.',
            cancelSuccess: 'Booking was canceled.',
            cancelWarning: 'Cancel booking',
            cancelationRefundDetails: `This will cancel your '{resource_name}' booking for {date}.<br>- You will receive a confirmation email<br>- If you paid for this booking, you will get a full refund`,
            cancelWarningForAdmin: `Cancel '{booking_title}'?`,
            cancelationRefundDetailsForAdmin: `This will cancel the '{booking_title}' for {date}.<br>
- The user will be automatically notified of the cancellation<br>
- If this was a paid booking, a refund will be processed<br>
- If this booking was added to a finalized membership invoice, no refund will be issued`,
        },
        guest: {
            notamemberyettitle: 'Not a member yet?',
            notamemberyetbody:
                'As a guest, you can only view this event. Become a member to discover what else your community has to offer. ',
            notmemberyetconfirmtitle: 'Become a member',
            notmemberyetdiscardtitle: 'Stay on event page',
        },
        imageguidelines:
            'Please avoid having text inside your image. The recommended image aspect ratio is 3x2 and the recommended image size is 1800x1200.',
        marketiterestsubmit: 'We will inform the author about your interest.',
        maxcharacters: 'max. {count} characters',
        moreinfoonourwebsite: 'For more options, please visit the community in your browser.',
        searchnomatches: 'No results match your search criteria',
        changessaved: '@:labels.changes @.lower:labels.saved',
        unsavedwarning: 'Your changes will be lost. Are you sure?',
        usernotexists: 'User does not exist or was deleted',
        userstatus: {
            3: 'Your account is currently suspended. This is probably due to a payment problem. Please contact customer service to clarify the situation.',
            4: 'Your account is currently canceled. Please subscribe to a plan to reactivate your membership.',
            5: 'Your account is currently waiting to be approved by an admin. As soon as your account has been approved, you will receive an email. Please make sure that you have confirmed your e-mail address. You have already received a separate email for this purpose.',
            7: "Your account is in guest status. As a guest, you can access 'My Events' and view public events. The rest of the community is unavailable. Contact the team to change your status.",
            7.2: "Your account is in guest status. As a guest, you can access 'My Events' and view public events. The rest of the community is unavailable. To upgrade, book a membership plan in the 'Membership' section.",
        },
        linkmustbevalidurl: 'Link must be valid URL',
        imageUploadError: 'An error occurred while uploading the image. Please try again.',
        imageUploadSizeError: 'The image is too large. Please choose a smaller image. Max 10 MB.',
        copyright: '© 2025 coapp GmbH. All rights reserved.',
        passwordlength: 'Password can not be longer than 56 characters',
        toUseThisFeatureActivatePayments: 'To give a ticket a price you need to activate payments.',
        registrationconfirmationmessage: 'You can find your ticket at any time on the event page.',
        noplanavailable: 'There are currently no plans available for you.',
        login: {
            registratonIsNoPossibleTitle: 'No registrations possible',
            registratonIsNoPossible:
                'Unfortunately, no further registrations are possible at the moment. Please try again later or contact the administrators.',
        },
        limitUsersAlmostReached:
            'You have reached 80% of the maximum amount of members in your plan. Once you have reached the limit, no more members can join your community. To ensure that all members can sign up, we recommend you to upgrade your subscription.',
        limitUsersReached:
            'You have reached the maximum amount of members in your plan. Upgrade your subscription now and invite more members.',
        limitAdminsReached:
            'You have reached the maximum amount of administrators in your plan. Upgrade your subscription now and add more administrators.',
        removeCobrandingTitle: 'Upgrade to remove coapp branding',
        removeCobrandingMsg: 'Upgrade to a paid plan, now.',
        removeCobrandingDoItLater: "I'll do it later",
        upgradeBarText: 'More features, bigger community – <strong>Upgrade now</strong>',
        upgradeBarTextMobileApp: 'A free community created with <strong>coapp</strong>',
        savetopreview: 'Save to preview',
        signup: {
            accountexists: 'Already have an account?',
            jointhecommunity: 'Sign up',
            noplanavailable: 'There are currently no plans available for you.',
            chooseyourplan: 'Select your plan to see the details and start the registration process.',
        },
        monetizationCollection: {
            subscriptions: {
                cancelationdateinfo:
                    'Users can always immediately upgrade their subscription to a plan with a higher price per billing cycle. The price per billing cycle is calculated including booked upgrades.',
            },
        },
    },
    userstatuslabels: {
        0: 'Active',
        1: 'Pending',
        2: 'Deleted',
        3: 'Suspended',
        4: 'Canceled',
        5: 'Waiting for approval',
        6: 'Rejected',
        7: 'Guest',
    },
    units: {
        hours: 'Hour | Hours',
        days: 'Day | Days',
        weeks: 'Week | Weeks',
        months: 'Month | Months',
        years: 'Year | Years',
    },
    booking_status_labels: {
        pending: 'Pending',
        waiting_for_payment: 'Waiting for payment',
        confirmed: 'Confirmed',
        cancelled: 'Canceled',
        failed: 'Failed',
    },
    errors: {
        atLeastOneMethod: 'At least one payment method must be enabled.',
        invalid: '@:labels.invalid',
        inputinvalid: 'Invalid input',
        inputrequired: 'This field is required',
        failedGeneric: 'An error occurred. Please try again.',
        failedToSaveChanges: 'Failed to save changes',
        invalidLoginCredentials: 'Invalid login credentials',
        mustBeValidEmail: 'Input must be a valid email address',
        noPaymentMethods: "You don't have any payment method. Please create one before subscribing to plan",
        usernotfound: 'User not found',
        localstorageDisabled:
            'LocalStorage is disabled. Without this browser feature, coapp cannot be used. Please enable LocalStorage in your browser settings to continue.',
        accessManagement: {
            // ErrIdentityIDIsRequired returned if client tries to update, delete or fetch user without providing access identity ID.
            ErrIdentityIDIsRequired: 'Invalid request: Identity ID is required, report this to the support team.',
            // ErrSpaceIDIsRequired is used when space ID is required but not provided.
            ErrSpaceIDIsRequired: 'Invalid request: Space ID is required, report this to the support team.',
            // ErrEmailIsRequired is used when email is required but not provided.
            ErrEmailIsRequired: 'Invalid request: Email is required, report this to the support team.',
            // ErrFailedToFetchUser is used when fetching user from access management system fails.
            ErrFailedToFetchUser:
                'Failed to fetch user from access management system. Make sure access management system is online and available and try again.',
            // ErrFailedToFetchUserFromDB is used when fetching user from the database fails
            ErrFailedToFetchUserFromDB: 'Failed to fetch user from database, contact the support team.',
            // ErrUserIsNotFound is used when user is not found in access management system.
            ErrUserIsNotFound: 'User not found in access management system',
            // ErrUserIsNotFoundInDB is used when user is not found in the database.
            ErrUserIsNotFoundInDB: 'User not found in database',
            // ErrFailedToCreateUser is used when user creation in access management system fails.
            ErrFailedToCreateUser:
                'Failed to create user in access management system. Make sure access management system is online and available and try again.',
            // ErrFailedToCreateUserInDB is used when user creation in the database fails.
            ErrFailedToCreateUserInDB: 'Failed to create user in database, contact the support team.',
            // ErrFailedToUpdateUser is used when user update in access management system fails.
            ErrFailedToUpdateUser:
                'Failed to update user in access management system. Make sure access management system is online and available and try again.',
            // ErrFailedToUpdateUserInDB is used when user update in the database fails.
            ErrFailedToUpdateUserInDB: 'Failed to update user in database, contact the support team.',
            // ErrFailedToDeleteUser is used when user deletion in access management system fails.
            ErrFailedToDeleteUser:
                'Failed to delete user in access management system. Make sure access management system is online and available and try again.',
            // ErrFailedToDeleteUserInDB is used when user deletion in the database fails.
            ErrFailedToDeleteUserInDB: 'Failed to delete user in database, contact the support team.',
            // ErrAccessManagementSystemIsNotAvailable is used when the access management system is not available/offline.
            ErrAccessManagementSystemIsNotAvailable:
                'Access management system is not available/offline. Make sure access management system is online and available and try again.',
            // ErrAccessManagementSystemIsNotConfigured is used when the access management system is not configured.
            ErrAccessManagementSystemIsNotConfigured:
                'Access management system is not configured, contact the support team.',
            // ErrAccessManagementSystemUnexpectedError is used when an unexpected error occurs in the access management system.
            ErrAccessManagementSystemUnexpectedError:
                'Unexpected error occurred in access management system. Make sure access management system is online and available and try again.',
            // ErrFailedToAssignKeyToUser is used when assigning a key to a user fails and should try another key.
            ErrFailedToAssignKeyToUser:
                'Failed to assign key to user, this likely means the key is invalid or already in use. Please try another key.',
            ErrFailedToAssignPolicyToUser:
                'Failed to assign policy to user, this likely means the policy is misconfigured or out of sync with coapp. Please resync the policies in coapp and try again.',
            ErrUnspecified: 'An unspecified error occurred in the access management system, contact the support team.',
        },
    },
    meta_title: {
        createYourCommunity: 'Create your community',
    },
    social: {
        facebook: 'Facebook',
        instagram: 'Instagram',
        linkedin: 'LinkedIn',
        twitter: 'Twitter/X',
        youtube: 'YouTube',
        reddit: 'Reddit',
    },
    languages: {
        de: 'German',
        en: 'English',
    },
    datetime: ({ named }) =>
        formattedDate(named('date'), named('format'), named('locale') ? named('locale') : null, named('customFormat')),
};
export default enUS;
